import { createWebHistory, createRouter } from 'vue-router'
import Products from './components/Products.vue'
import ProductDetail from './components/ProductDetail.vue'
import Home from "./components/Home.vue";
import AboutUs from "./components/AboutUs.vue";
import Markets from "./components/Markets.vue";
import Contact from "./components/Contact.vue";

const routes = [
    { 
        path: '/',
        component: Home,
    },
    { 
      path: '/about',
      component: AboutUs,
    },
    { 
      path: '/products/:pageName',
      component: Products,
    },
    { 
      path: '/products/:pageName/:productName',
      component: ProductDetail,
    },
    { 
      path: '/markets',
      component: Markets,
    },
    { 
      path: '/contact',
      component: Contact,
    },
]

const router = createRouter({
    history: createWebHistory(),
    routes,
    strict: true,
    scrollBehavior() {
      return {top: 0}
    }
  })

export default router